<dx-popup
    #specifyApplyAmountBox
    width="60%"
    height="80%"
    title="Specify Apply Amount for each line items"
    [showTitle]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="false"
    [(visible)]="visible"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="specify-apply-amountBox-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto" *ngIf="sourceLineItemAppliedAmountsDataEntries?.length > 0">
                <dx-data-grid
                    #appliedAmountGrid
                    class="cc-vertical-center-cell-data-grid"
                    width="100%"
                    height="90%"
                    [dataSource]="sourceLineItemAppliedAmountsDataEntries"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    noDataText="No data to display"
                >
                    <dxi-column caption="Line #" cellTemplate="lineTemplate" [width]="100"></dxi-column>
                    <dxi-column
                        dataField="unappliedAmount"
                        caption="Unapplied Amount"
                        dataType="number"
                        [format]="currencyFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="appliedAmount"
                        caption="Applied Amount"
                        dataType="number"
                        [format]="currencyFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="remainingUnapplied"
                        caption="Remaining Unapplied"
                        dataType="number"
                        [format]="currencyFormat"
                    ></dxi-column>

                    <div *dxTemplate="let item of 'lineTemplate'">
                        <span>
                            {{ item.row.rowIndex + 1 }}
                        </span>
                    </div>

                    <dxo-header-filter [visible]="false"></dxo-header-filter>
                    <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                    <dxo-group-panel [visible]="false"></dxo-group-panel>
                    <dxo-sorting mode="none"></dxo-sorting>
                    <dxo-scrolling mode="standard"></dxo-scrolling>
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>
                </dx-data-grid>
            </dxi-item>

            <dxi-item [ratio]="1" *ngIf="sourceLineItemAppliedAmountsDataEntries?.length > 0">
                <dx-data-grid
                    #targetGrid
                    class="cc-vertical-center-cell-data-grid"
                    width="100%"
                    height="90%"
                    [dataSource]="sourceItems"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    noDataText="No data to display"
                >
                    <dxi-column
                        dataField="itemNumber"
                        dataType="number"
                        caption="Line #"
                        cellTemplate="lineTemplate"
                        [width]="120"
                    ></dxi-column>

                    <dxi-column
                        dataField="amount"
                        caption="Amount"
                        dataType="number"
                        [format]="currencyFormat"
                    ></dxi-column>
                    <dxi-column dataField="glAccountNumber" caption="GL Account" dataType="string"></dxi-column>
                    <dxi-column
                        dataField="offsetGLAccountNumber"
                        caption="Offset GL Account"
                        dataType="string"
                    ></dxi-column>
                    <dxi-column
                        dataField="dimensions"
                        caption="Dimensions"
                        dataType="string"
                        cellTemplate="dimensionTemplate"
                    ></dxi-column>

                    <div *dxTemplate="let row of 'dimensionTemplate'">
                        <div *ngFor="let dim of row.data.dimensions">
                            {{ dim.dimensionTitle }}
                            <span *ngIf="dim.dimensionTitle && dim.dimensionOptionTitle">:</span>
                            {{ dim.dimensionOptionTitle }}
                        </div>
                    </div>

                    <div *dxTemplate="let row of 'lineTemplate'">
                        <div>Source Item #{{ row.data.itemNumber }}</div>
                    </div>

                    <div *dxTemplate="let source of 'detail'">
                        <strong>Target Line Items</strong>
                        <dx-data-grid
                            #targetGrid
                            class="cc-vertical-center-cell-data-grid"
                            width="100%"
                            height="90%"
                            keyExpr="sourceItemId"
                            [dataSource]="source.data.targetItems"
                            [allowColumnReordering]="true"
                            [allowColumnResizing]="true"
                            [columnAutoWidth]="true"
                            [showBorders]="true"
                            [showColumnLines]="true"
                            [showRowLines]="true"
                            noDataText="No data to display"
                        >
                            <dxi-column
                                dataField="isSelect"
                                caption="Select"
                                alignment="center"
                                cellTemplate="selectTemplate"
                            ></dxi-column>
                            <dxi-column
                                dataField="appliedAmount"
                                caption="Apply Amount"
                                dataType="number"
                                cellTemplate="applyAmountTemplate"
                                [width]="90"
                                [format]="currencyFormat"
                            ></dxi-column>

                            <dxi-column
                                dataField="amount"
                                caption="Amount"
                                dataType="number"
                                [format]="currencyFormat"
                            ></dxi-column>
                            <dxi-column
                                dataField="openBalance"
                                caption="Open Balance"
                                dataType="number"
                                [format]="currencyFormat"
                            ></dxi-column>
                            <dxi-column dataField="glAccountNumber" caption="GL Account" dataType="string"></dxi-column>
                            <dxi-column
                                dataField="offsetGLAccountNumber"
                                caption="Offset GL Account"
                                dataType="string"
                            ></dxi-column>

                            <dxi-column
                                dataField="lineItems"
                                caption="Dimensions"
                                dataType="string"
                                cellTemplate="dimensionTemplate"
                            ></dxi-column>

                            <div *dxTemplate="let row of 'dimensionTemplate'">
                                <div *ngFor="let dim of row.data.dimensions">
                                    {{ dim.dimensionTitle }}
                                    <span *ngIf="dim.dimensionTitle && dim.dimensionOptionTitle">:</span>
                                    {{ dim.dimensionOptionTitle }}
                                </div>
                            </div>

                            <div *dxTemplate="let row of 'applyAmountTemplate'">
                                <dx-number-box
                                    [format]="currencyFormat"
                                    [(value)]="row.data.currentAppliedAmount"
                                    (onValueChanged)="applyAmountChanged($event, row.data)"
                                ></dx-number-box>
                            </div>

                            <div *dxTemplate="let row of 'selectTemplate'">
                                <dx-check-box
                                    [(value)]="row.data.isSelect"
                                    (onValueChanged)="onRowSelect($event, row.data)"
                                ></dx-check-box>
                            </div>

                            <dxo-header-filter [visible]="false"></dxo-header-filter>
                            <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                            <dxo-group-panel [visible]="false"></dxo-group-panel>
                            <dxo-sorting mode="none"></dxo-sorting>
                            <dxo-scrolling mode="standard"></dxo-scrolling>
                            <dxo-load-panel [enabled]="false"></dxo-load-panel>
                        </dx-data-grid>
                    </div>

                    <dxo-master-detail [enabled]="false" [autoExpandAll]="true" template="detail"></dxo-master-detail>
                    <dxo-header-filter [visible]="false"></dxo-header-filter>
                    <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                    <dxo-group-panel [visible]="false"></dxo-group-panel>
                    <dxo-sorting mode="none"></dxo-sorting>
                    <dxo-scrolling mode="standard"></dxo-scrolling>
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>
                </dx-data-grid>
            </dxi-item>

            <dxi-item baseSize="auto" *ngIf="sourceLineItemAppliedAmountsDataEntries?.length === 0">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%" [colCount]="1">
                        <dxi-item>
                            <dxo-label text="Remaining Unapplied Amount"></dxo-label>
                            <div *dxTemplate>
                                {{ remainingUnappliedAmount }}
                            </div>
                        </dxi-item>
                        <dxi-item cssClass="add-left-padding">
                            <dxo-label text="Total Apply"></dxo-label>
                            <div *dxTemplate>
                                {{ totalApplyAmount }}
                            </div>
                        </dxi-item>
                        <dxi-item cssClass="add-left-padding">
                            <dxo-label text="Remaining Unapplied"></dxo-label>
                            <div *dxTemplate>
                                {{ remainingUnapplied }}
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1" *ngIf="sourceLineItemAppliedAmountsDataEntries?.length === 0">
                <div *dxTemplate>
                    <strong>Target Line Items</strong>
                    <dx-data-grid
                        #targetGrid
                        class="cc-vertical-center-cell-data-grid"
                        width="100%"
                        height="90%"
                        keyExpr="itemId"
                        [dataSource]="targetItems"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        noDataText="No data to display"
                    >
                        <dxi-column
                            dataField="isSelect"
                            caption="Select"
                            alignment="center"
                            cellTemplate="selectTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataField="appliedAmount"
                            caption="Apply Amount"
                            dataType="number"
                            cellTemplate="applyAmountTemplate"
                            [width]="90"
                            [format]="currencyFormat"
                        ></dxi-column>

                        <dxi-column
                            dataField="amount"
                            caption="Amount"
                            dataType="number"
                            [format]="currencyFormat"
                        ></dxi-column>
                        <dxi-column
                            dataField="openBalance"
                            caption="Open Balance"
                            dataType="number"
                            [format]="currencyFormat"
                        ></dxi-column>
                        <dxi-column dataField="glAccountNumber" caption="GL Account" dataType="string"></dxi-column>
                        <dxi-column
                            dataField="offsetGLAccountNumber"
                            caption="Offset GL Account"
                            dataType="string"
                        ></dxi-column>

                        <dxi-column
                            dataField="lineItems"
                            caption="Dimensions"
                            dataType="string"
                            cellTemplate="dimensionTemplate"
                        ></dxi-column>

                        <div *dxTemplate="let row of 'dimensionTemplate'">
                            <div *ngFor="let dim of row.data.dimensions">
                                {{ dim.dimensionTitle }}
                                <span *ngIf="dim.dimensionTitle && dim.dimensionOptionTitle">:</span>
                                {{ dim.dimensionOptionTitle }}
                            </div>
                        </div>

                        <div *dxTemplate="let row of 'applyAmountTemplate'">
                            <dx-number-box
                                [format]="currencyFormat"
                                [(value)]="row.data.appliedAmount"
                                (onValueChanged)="targetApplyAmountChanged($event, row.data)"
                            ></dx-number-box>
                        </div>

                        <div *dxTemplate="let row of 'selectTemplate'">
                            <dx-check-box
                                [(value)]="row.data.isSelect"
                                (onValueChanged)="onTargetRowSelect($event, row.data)"
                            ></dx-check-box>
                        </div>

                        <dxo-header-filter [visible]="false"></dxo-header-filter>
                        <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                        <dxo-group-panel [visible]="false"></dxo-group-panel>
                        <dxo-sorting mode="none"></dxo-sorting>
                        <dxo-scrolling mode="standard"></dxo-scrolling>
                        <dxo-load-panel [enabled]="false"></dxo-load-panel>
                    </dx-data-grid>
                </div>
            </dxi-item>

            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="closeIcon"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Save"
                                useSubmitBehavior="true"
                                [icon]="saveIcon"
                                [disabled]="totalApplyAmount === 0"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
